const termsMap = {
  member: require('@/assets/terms/审计平台会员条款.html'),
  service: require('@/assets/terms/服务协议和隐私服务.html')
}

function getTermsHtml(type) {
  const htmlModule = termsMap[type]
  return typeof htmlModule === 'string' ? htmlModule : (htmlModule?.default || '')
}

export function openTerms(type) {
  const html = getTermsHtml(type)
  if (!html) {
    return null
  }

  const blob = new Blob([html], { type: 'text/html;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const newWindow = window.open(url, '_blank')

  setTimeout(() => {
    URL.revokeObjectURL(url)
  }, 60000)

  return newWindow
}
